import {View} from 'MWC';
import tpl from '../templates/Banner.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
